import { render } from "./Upload.vue?vue&type=template&id=46023212&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=46023212&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46023212"

export default script